import React, { useState, useEffect, useRef } from "react";
import {
  FaChevronLeft,
  FaChevronRight,
  FaTimes,
  FaFilter,
} from "react-icons/fa";
import axios from "../../api/axiosInstance";
import GlobalLoader from "./GlobalLoader";

const FilterPillBar = ({ activeFilters, setActiveFilters, onFilterChange }) => {
  const [filters, setFilters] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const scrollRef = useRef(null);

  const fetchFilterOptions = async () => {
    try {
      const res = await axios.get("/api/matches/filter-options/", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      const structuredFilters = [
        { label: "Gotra", value: "gothra", options: res.data.gothra || [] },
        {
          label: "Marital Status",
          value: "marital_status",
          options: res.data.marital_status || [],
        },
        {
          label: "Mother Tongue",
          value: "mother_tongue",
          options: res.data.mother_tongue || [],
        },
        {
          label: "Highest Education",
          value: "highest_education",
          options: res.data.highest_education || [],
        },
        {
          label: "Work Location",
          value: "work_location_city",
          options: res.data.work_location_city || [],
        },
        { label: "Profiles with Photo", value: "photo", options: ["Yes"] },
      ];

      setFilters(structuredFilters);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchFilterOptions();
  }, []);

  const scroll = (direction) => {
    if (!scrollRef.current) return;
    scrollRef.current.scrollBy({
      left: direction === "left" ? -150 : 150,
      behavior: "smooth",
    });
  };

  const handleSelect = (filterKey, option) => {
    const updatedFilters = { ...activeFilters, [filterKey]: option };
    setActiveFilters(updatedFilters);
    onFilterChange(updatedFilters);
  };

  const clearFilter = (filterKey) => {
    const updatedFilters = { ...activeFilters };
    delete updatedFilters[filterKey];
    setActiveFilters(updatedFilters);
    onFilterChange(updatedFilters);
  };

  if (!filters) {
    return <GlobalLoader />;
  }

  return (
    <>
      {/* Desktop / Tablet Fixed Filter Bar */}
      <div className="hidden sm:flex fixed top-0 left-0 right-0 z-20 bg-white border-b shadow-sm px-4 py-2 items-center gap-4 overflow-hidden">
        <button
          onClick={() => scroll("left")}
          className="p-2 border rounded-full hover:bg-gray-100"
        >
          <FaChevronLeft />
        </button>
        <div
          ref={scrollRef}
          className="flex gap-2 overflow-x-auto hide-scrollbar w-full"
        >
          {filters.map((filter) => (
            <div
              key={filter.value}
              className={`flex items-center gap-1 px-3 py-1 rounded-full border whitespace-nowrap relative ${
                activeFilters[filter.value]
                  ? "bg-pink-600 text-white"
                  : "bg-white text-gray-800 hover:bg-gray-100"
              }`}
            >
              <select
                className={`bg-transparent outline-none cursor-pointer ${
                  activeFilters[filter.value] ? "text-white" : "text-gray-800"
                }`}
                value={activeFilters[filter.value] || ""}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  if (selectedValue !== "") {
                    handleSelect(filter.value, selectedValue);
                  } else {
                    clearFilter(filter.value);
                  }
                }}
              >
                <option value="">{filter.label}</option>
                {filter.options.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
              {activeFilters[filter.value] && (
                <FaTimes
                  className="cursor-pointer ml-1"
                  onClick={() => clearFilter(filter.value)}
                />
              )}
            </div>
          ))}
        </div>
        <button
          onClick={() => scroll("right")}
          className="p-2 border rounded-full hover:bg-gray-100"
        >
          <FaChevronRight />
        </button>
      </div>

      {/* Mobile Button */}
      <button
        onClick={() => setIsModalOpen(true)}
        className="fixed bottom-4 right-4 sm:hidden p-3 bg-pink-600 text-white rounded-full shadow-lg z-40"
      >
        <FaFilter size={20} />
      </button>

      {/* Mobile Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-end sm:hidden z-50">
          <div className="bg-white w-full max-h-[70%] rounded-t-lg p-4 overflow-y-auto animate-slide-up">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold">Filters</h2>
              <button onClick={() => setIsModalOpen(false)} className="p-2">
                <FaTimes size={20} />
              </button>
            </div>
            <div className="flex flex-col gap-2">
              {filters.map((filter) => (
                <div key={filter.value} className="flex flex-col">
                  <label className="text-sm font-medium mb-1">
                    {filter.label}
                  </label>
                  <select
                    className="border rounded p-2"
                    value={activeFilters[filter.value] || ""}
                    onChange={(e) => {
                      const selectedValue = e.target.value;
                      if (selectedValue !== "") {
                        handleSelect(filter.value, selectedValue);
                      } else {
                        clearFilter(filter.value);
                      }
                    }}
                  >
                    <option value="">Select {filter.label}</option>
                    {filter.options.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
              ))}
            </div>
            <button
              onClick={() => setIsModalOpen(false)}
              className="mt-4 w-full bg-pink-600 text-white py-2 rounded"
            >
              Apply Filters
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default FilterPillBar;

// import React, { useState, useEffect, useRef } from "react";
// import { FaChevronLeft, FaChevronRight, FaTimes } from "react-icons/fa";
// import axios from "../../api/axiosInstance";
// import GlobalLoader from "./GlobalLoader";

// const FilterPillBar = ({ activeFilters, setActiveFilters, onFilterChange }) => {
//   const [filters, setFilters] = useState(null); // dynamic filters
//   const scrollRef = useRef(null);

//   const fetchFilterOptions = async () => {
//     try {
//       const res = await axios.get("/api/matches/filter-options/", {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//         },
//       });
//       const structuredFilters = [
//         { label: "Religion", value: "religion", options: res.data.religion },
//         { label: "Marital Status", value: "marital_status", options: res.data.marital_status },
//         { label: "Mother Tongue", value: "mother_tongue", options: res.data.mother_tongue },
//         { label: "Highest Education", value: "highest_education", options: res.data.highest_education },
//         { label: "Work Location", value: "work_location_city", options: res.data.work_location_city },
//         { label: "Profiles with Photo", value: "photo", options: ["Yes"] },
//       ];
//       setFilters(structuredFilters);
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     fetchFilterOptions();
//   }, []);

//   const scroll = (direction) => {
//     if (!scrollRef.current) return;
//     scrollRef.current.scrollBy({
//       left: direction === "left" ? -150 : 150,
//       behavior: "smooth",
//     });
//   };

//   const handleSelect = (filterKey, option) => {
//     const updatedFilters = { ...activeFilters, [filterKey]: option };
//     setActiveFilters(updatedFilters);
//     onFilterChange(updatedFilters);
//   };

//   const clearFilter = (filterKey) => {
//     const updatedFilters = { ...activeFilters };
//     delete updatedFilters[filterKey];
//     setActiveFilters(updatedFilters);
//     onFilterChange(updatedFilters);
//   };

//   if (!filters) {
//     return <GlobalLoader />;
//   }

//   return (
//     <div className="flex items-center gap-2 mb-4 overflow-hidden">
//       <button
//         onClick={() => scroll("left")}
//         className="p-2 border rounded-full hover:bg-gray-100"
//       >
//         <FaChevronLeft />
//       </button>
//       <div ref={scrollRef} className="flex gap-2 overflow-x-auto hide-scrollbar">
//         {filters.map((filter) => (
//           <div
//             key={filter.value}
//             className={`flex items-center gap-1 px-3 py-1 rounded-full border whitespace-nowrap relative ${
//               activeFilters[filter.value] ? "bg-pink-600 text-white" : "bg-white text-gray-800 hover:bg-gray-100"
//             }`}
//           >
//             <select
//               className={`bg-transparent outline-none cursor-pointer ${
//                 activeFilters[filter.value] ? "text-white" : "text-gray-800"
//               }`}
//               value={activeFilters[filter.value] || ""}
//               onChange={(e) => {
//                 const selectedValue = e.target.value;
//                 if (selectedValue !== "") {
//                   handleSelect(filter.value, selectedValue);
//                 } else {
//                   clearFilter(filter.value);
//                 }
//               }}
//             >
//               <option value="">{filter.label}</option>
//               {filter.options.map((option) => (
//                 <option key={option} value={option}>
//                   {option}
//                 </option>
//               ))}
//             </select>
//             {activeFilters[filter.value] && (
//               <FaTimes
//                 className="cursor-pointer ml-1"
//                 onClick={() => clearFilter(filter.value)}
//               />
//             )}
//           </div>
//         ))}
//       </div>
//       <button
//         onClick={() => scroll("right")}
//         className="p-2 border rounded-full hover:bg-gray-100"
//       >
//         <FaChevronRight />
//       </button>
//     </div>
//   );
// };

// export default FilterPillBar;
